import Operations from "./Operations";

const TroubleshootingGuides = () => <Operations resource="guides" />;

export default TroubleshootingGuides;
